import { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "@/i18n";
import { useAuth } from "@/auth";
import { api } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MEDALS = ["🥇", "🥈", "🥉"];

// Saves the finished bonus run (when the player is signed in) and shows the
// global Top-5 board for that bonus mode. Used by the Volcano and Ocean rounds.
export function BonusLeaderboard({ mode, levelIndex, levelName, character, score, difficulty = "normal" }) {
  const { t } = useLang();
  const { user } = useAuth();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let active = true;
    const run = async () => {
      if (user && score > 0) {
        try {
          await api.saveScore({
            player_name: user.username,
            character: character?.id || character?.name || "",
            level_index: levelIndex,
            level_name: levelName,
            score,
            cordobas: score,
            completed: true,
            difficulty,
            mode,
          });
        } catch (e) { /* ignore save errors, still show the board */ }
      }
      try {
        const r = await axios.get(`${API}/scores?mode=${mode}&sort=score&limit=5`);
        if (active) setRows(r.data);
      } catch (e) { if (active) setRows([]); }
    };
    run();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mt-3 mb-1 text-left" data-testid={`bonus-board-${mode}`}>
      <p className="font-pixel text-[9px] text-[#FFEB3B] text-center mb-1">🏆 {t("bonusTop5", "TOP 5")}</p>
      {rows === null ? (
        <p className="font-vt text-sm text-white/70 text-center py-1">{t("loading", "Loading...")}</p>
      ) : rows.length === 0 ? (
        <p className="font-vt text-sm text-white/60 text-center py-1">{t("noScores")}</p>
      ) : (
        <div className="space-y-0.5">
          {rows.map((s, i) => {
            const isMe = user && (s.player_name || "").toLowerCase() === user.username.toLowerCase();
            return (
              <div
                key={s.id || i}
                data-testid={`bonus-board-row-${i}`}
                className="grid grid-cols-12 font-vt text-base items-center px-1.5 py-0.5 rounded"
                style={{
                  color: i === 0 ? "#FFEB3B" : i === 1 ? "#dddddd" : i === 2 ? "#FF7043" : "#fff",
                  background: isMe ? "rgba(0,103,198,0.28)" : "transparent",
                }}
              >
                <span className="col-span-2 font-pixel text-[8px]">{MEDALS[i] || i + 1}</span>
                <span className="col-span-7 truncate">🇳🇮 {s.player_name}</span>
                <span className="col-span-3 text-right">C${s.score}</span>
              </div>
            );
          })}
        </div>
      )}
      {!user && (
        <p className="font-vt text-xs text-[#FFB300] text-center mt-1">{t("loginToSave")}</p>
      )}
    </div>
  );
}
